<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.independent')}}
    Icon(icon="independent" classes="p-title__icon")
  Ownership(risk="independent" risk_object="rc_exploitation")
  Ownership(risk="independent" risk_object="e_reputation")
  Ownership(risk="independent" risk_object="rc_professional" v-if="shouldInsureLiberalProfession")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  },
  computed: {
    shouldInsureLiberalProfession () {
      return this.$store.state.person.liberal_profession
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/Independent.vue